import PatientsList from './PatientsList';

export default PatientsList;